<script lang="ts">
    
    import type { Game } from "../Model/Game";
    import Watch from "./Watch.svelte";

    export let game: Game;

    function formatTime(timeToStart: number): string {
        const minutes = Math.floor(timeToStart / 60);
        let seconds: number | string = timeToStart % 60;
        if (seconds < 10) seconds = `0${seconds}`;
        return `${minutes}:${seconds}`;
    }

</script>

<Watch state={game.timeToStart} let:value>
    {formatTime(value)}
</Watch>
